(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageBeneficiaries', [
			'$rootScope',
			'$scope',
			'SettingsFactory',
			ManageBeneficiariesFunction
		]);

	function ManageBeneficiariesFunction(
		$rootScope,
		$scope,
		SettingsFactory
	) {
		var manageBeneficiaries = this;

		manageBeneficiaries.openConfirmationModal = function (selectedBeneficiaryId) {
			manageBeneficiaries.deleteId = selectedBeneficiaryId;
			$scope.$broadcast('confirmationModal:open');
		};

		manageBeneficiaries.handleDelete = function () {
			SettingsFactory.beneficiary.delete(manageBeneficiaries.deleteId)
				.then(function () {
					loadBeneficiaries();

					$rootScope.ToastFactory.show({
						message: 'Beneficiary deleted.',
						type: 'success'
					});
				});
		};

		function loadBeneficiaries() {
			SettingsFactory.beneficiary.getAll()
				.then(function(beneficiaryList) {
					manageBeneficiaries.beneficiaryList = beneficiaryList;
				});
		}

		manageBeneficiaries.$onInit = function () {
			loadBeneficiaries();
		};
	}
})(window.angular);